import { defineCopy } from '@floorfile/i18n'
import { maintenanceCopy } from './copy'

export const maintenanceOfflineCopy = defineCopy('maintenance', { offlineAction: maintenanceCopy.en.offlineAction })
